import { forwardRef, Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { DependencyTreeCanActivate } from 'app/core/guards/dependency-tree.guard';
import { UserContextLoadGuard } from 'app/core/guards/user-context-load.guard';
import { GetDefinitionsGuard } from 'app/core/store/definitions/definitions.resolve';
import { AuthorizationGuard } from 'app/core/store/session/authorization/authorization.resolve';
import { Observable, of } from 'rxjs';
import * as fromRoot from '..';
import { RootState } from '../index';
import { TemplatesLoadAction } from './template.actions';
import { TemplateState } from './template.interface';
import { logger } from 'app/core/util/logger';
import { filter, first, switchMap } from 'rxjs/operators';

/**
 * Guard to async load the templates before following a route
 */
@Injectable({ providedIn: 'root' })
export class GetRelocationTemplatesGuard implements CanActivate, DependencyTreeCanActivate {
  private store: Store<fromRoot.RootState>;

  constructor(@Inject(forwardRef(() => Store)) store) {
    this.store = store;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    logger.debug(`In GetRelocationTemplatesGuard`);
    return this.store.pipe(
      first(),
      switchMap((root: RootState) => {
        this.store.dispatch(new TemplatesLoadAction({ type: 'RELOCATION' }));
        return this.store.select('template').pipe(
          filter((template: TemplateState) => template.loadSuccess),
          first(),
          switchMap(() => {
            return of(true);
          })
        );
      })
    );
  }

  getDependencies(): any {
    return [UserContextLoadGuard, AuthorizationGuard, GetDefinitionsGuard];
  }

  getDependencyRouteData(): any {
    return {
      authorization: 'canRelocate',
    };
  }
}
